import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';
import { useMe } from '@/hooks/use-me';

import { downloadRawDataMocked } from './__mocked_data__/download-raw-data';

export namespace DownloadRawDataMutation {
  export type Input = {
    systemId: string;
    groupId: string;
  };
  export type Output = {
    file: Blob;
  };

  function useMutationFn() {
    const me = useMe();
    const downloadRawData = useInjectFeApiContext(
      FeApi.warrantyV2DownloadMetricsRetrieve,
    );

    return async function mutationFn(input: Input): Promise<Output> {
      if (me.config.id === '49') {
        return downloadRawDataMocked(input);
      }

      const result = await ok(
        downloadRawData({
          systemId: input.systemId,
          metricGroup: input.groupId,
        }),
      );

      const file = new Blob([result], { type: 'text/csv' });

      return {
        file,
      };
    };
  }

  export function useMutation() {
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn,
    });
  }
}
